import PropTypes from 'prop-types'

import Moment from 'react-moment'
import { Link, useRouteMatch } from 'react-router-dom'
import { dateformat, isNullOrUndefined } from 'utils'
import Button from 'components/form/Button'
import { useConfirm } from 'features/dialog/Confirm'
import { success, fail } from 'features/toast/Toast'
import { useDispatch } from 'react-redux'
import {
  fetchLinkedTracks,
  fetchUnlinkedTracks,
  unlinkTrackRight,
} from 'features/crux/tracker/list/trackerListSlice'
import TrackerServiceTooltip from 'features/crux/tracker/TrackerServiceTooltip'

const LinkedTrackItem = ({
  data: {
    trackId,
    linkedAt,
    trackName,
    trackLinkedServices,
    linkedServiceNamesTitle,
    population,
    lastEventTs,
  },
}) => {
  const dispatch = useDispatch()
  const { url } = useRouteMatch()
  const [UnLinkConfirm, showUnLinkConfirm] = useConfirm()
  const handleDelete = async ({ isConfirmed }) => {
    if (isConfirmed) {
      const { error, payload } = await dispatch(unlinkTrackRight(trackId))
      if (error) {
        fail(payload?.message || '알 수 없는 에러가 발생했습니다.')
      } else {
        success('해당 광고계정과 픽셀 & SDK 연동이 해제되었습니다.')
        dispatch(fetchLinkedTracks())
        dispatch(fetchUnlinkedTracks())
      }
    }
  }
  return (
    <>
      <td>
        <div className="inner_tbl">
          <Moment format={dateformat}>{linkedAt}</Moment>
        </div>
      </td>
      <td>
        <div className="inner_tbl">
          <Link to={`${url}/${trackId}`} className="link_txt">
            {trackName}
            <span className="desc_subtxt">{trackId}</span>
          </Link>
        </div>
      </td>
      <td>
        <div className="inner_tbl">
          {linkedServiceNamesTitle ? (
            <TrackerServiceTooltip data={trackLinkedServices}>
              {linkedServiceNamesTitle}
            </TrackerServiceTooltip>
          ) : (
            '-'
          )}
        </div>
      </td>
      <td className="align_r">
        <div className="inner_tbl">
          {isNullOrUndefined(lastEventTs) ? '-' : population.toLocaleString()}
        </div>
      </td>
      <td>
        <div className="inner_tbl">
          <p className="ad_state ico_state">
            {isNullOrUndefined(lastEventTs) ? (
              <>
                <span className="ico_off">off</span>수집전
              </>
            ) : (
              <>
                <span className="ico_on">on</span>수집중
              </>
            )}
          </p>
        </div>
      </td>
      <td className="align_c">
        <div className="inner_tbl">
          <Button size="small" onClick={showUnLinkConfirm}>
            연동 해제
          </Button>
        </div>
      </td>
      <UnLinkConfirm title="픽셀 & SDK 연동 해제" onClose={handleDelete}>
        광고계정에 연동된 픽셀 & SDK를 해제하시겠습니까?
      </UnLinkConfirm>
    </>
  )
}

export default LinkedTrackItem

LinkedTrackItem.propTypes = {
  data: PropTypes.shape({
    trackId: PropTypes.string.isRequired,
    trackName: PropTypes.string.isRequired,
    linkedAt: PropTypes.string.isRequired,
    trackLinkedServices: PropTypes.object,
    linkedServiceNamesTitle: PropTypes.string,
    population: PropTypes.number,
    lastEventTs: PropTypes.number,
  }),
}
